interface SparklineProps {
    values: number[]
    width?: number
    height?: number
    color?: string
    fillColor?: string
}

export default function Sparkline({
    values,
    width = 80,
    height = 24,
    color = '#3b82f6',
    fillColor
}: SparklineProps) {
    if (values.length < 2) return null

    const min = Math.min(...values)
    const max = Math.max(...values)
    const range = max - min || 1

    const pad = 1
    const w = width - pad * 2
    const h = height - pad * 2

    const points = values.map((v, i) => {
        const x = pad + (i / (values.length - 1)) * w
        const y = pad + h - ((v - min) / range) * h
        return `${x.toFixed(1)},${y.toFixed(1)}`
    })

    const linePath = `M${points.join(' L')}`
    const fillPath = fillColor
        ? `${linePath} L${(pad + w).toFixed(1)},${(pad + h).toFixed(1)} L${pad},${(pad + h).toFixed(1)} Z`
        : undefined

    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            className="inline-block shrink-0"
        >
            {fillPath && (
                <path d={fillPath} fill={fillColor} opacity="0.15" />
            )}
            <path
                d={linePath}
                fill="none"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Current value dot */}
            <circle
                cx={parseFloat(points[points.length - 1].split(',')[0])}
                cy={parseFloat(points[points.length - 1].split(',')[1])}
                r="2"
                fill={color}
            />
        </svg>
    )
}
